import React from "react";
import { Helmet } from "react-helmet";
import { Outlet } from "react-router-dom";
import { Row, Col, Typography } from "antd";
import { ErrorBoundary } from "react-error-boundary";

import { useAppSelector } from "app/hooks";
import ErrorFallback from "components/ErrorFallback";
import {
  useGetNIBSSStatusEnumQuery,
  useGetSortCodeTypeEnumQuery,
  useGetTransactionTypeEnumQuery,
} from "app/configApiSlice";

import { TableWrapper, TransactionyProcessingContainer } from "./styled";

const { Title } = Typography;

const Transaction: React.FC = () => {
  const sortCodeEnum = useGetSortCodeTypeEnumQuery();
  const NIBSSStatusEnum = useGetNIBSSStatusEnumQuery();
  const transactionTypeEnum = useGetTransactionTypeEnumQuery();

  const { layout } = useAppSelector((state) => state.tPlusOneProcessing);

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Helmet>
        <title>NEFT Settlement | T + 1 Processing</title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      <TransactionyProcessingContainer>
        <Row>
          <Col className="heading" span={24}>
            <Title level={4}>{layout.title}</Title>
          </Col>
        </Row>

        <TableWrapper>
          <Outlet
            context={{
              sortCode: sortCodeEnum.data,
              NIBSSStatus: NIBSSStatusEnum.data,
              transactionType: transactionTypeEnum.data,
            }}
          />
        </TableWrapper>
      </TransactionyProcessingContainer>
    </ErrorBoundary>
  );
};

export default Transaction;
